module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "star-rating"
  }, _vm._l((_vm.stars), function(star) {
    return _c('span', {
      staticClass: "star",
      class: {
        'star-active': _vm.active, 'star-half': _vm.isHalf(star)
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/Eugen/.config/yarn/global/~/vue-loader/lib/template-compiler?{"id":"data-v-d1779b96"}!/Users/Eugen/.config/yarn/global/~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/StarRating.vue
// module id = 212
// module chunks = 0